var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.63 22.266a3.903 3.903 0 0 0 3.92-3.78l.448-13.832h2.1c.308 0 .56-.252.56-.56a.562.562 0 0 0-.56-.56h-5.88v-1.26a2.247 2.247 0 0 0-2.24-2.24H8.722a2.247 2.247 0 0 0-2.24 2.24v1.26H.574a.562.562 0 0 0-.56.56c0 .308.252.56.56.56h2.1l.448 13.832a3.903 3.903 0 0 0 3.92 3.78h7.588zM7.602 2.274c0-.616.504-1.12 1.12-1.12h4.256c.616 0 1.12.504 1.12 1.12v1.26H7.602v-1.26zM4.27 18.43 3.822 4.626h14.084L17.43 18.43a2.81 2.81 0 0 1-2.8 2.716H7.07a2.791 2.791 0 0 1-2.8-2.716z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.85 17.562c.308 0 .56-.252.56-.56V8.63a.562.562 0 0 0-.56-.56.562.562 0 0 0-.56.56v8.372c0 .308.252.56.56.56zM7.49 17.562c.308 0 .56-.252.56-.56V8.63a.562.562 0 0 0-.56-.56.562.562 0 0 0-.56.56v8.372c0 .308.252.56.56.56zM14.21 17.562c.308 0 .56-.252.56-.56V8.63a.562.562 0 0 0-.56-.56.562.562 0 0 0-.56.56v8.372c0 .308.252.56.56.56z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.5f42e4371c97b2eb61d8e37e7cc05a49.svg";
export { ForwardRef as ReactComponent };